module.exports = __webpack_public_path__ + "img/cartaz-mobile.12c6610d.jpg";